import React, { useState, useCallback } from "react";
import { FaTimes, FaChevronLeft, FaChevronRight } from "react-icons/fa";
import "./Gallery.css";

const galleryImages = [
  {
    id: 1,
    src: "/assets/Events/RadianceCPAddress.jpg",
    alt: "Radiance 2.0 - New ChairWoman's Address",
    category: "Radiance",
  },
  {
    id: 2,
    src: "/assets/Events/EnginuityWSO2Session.jpg",
    alt: "Enginuity 2.0 - Industry Visit",
    category: "Enginuity",
  },
  {
    id: 3,
    src: "/assets/Events/FuturoOC.jpg",
    alt: "Futuro 3.0 - Organizing Committee",
    category: "Futuro",
  },
  {
    id: 4,
    src: "/assets/Events/Hackeliteteam.jpg",
    alt: "Hackelite 2.0 - Finale Audience Capture",
    category: "Hackelite",
  },
  {
    id: 5,
    src: "/assets/Events/NurtureNookDrawings.jpg",
    alt: "Nurturenook - Drawing Session",
    category: "Nurturenook",
  },
  {
    id: 6,
    src: "/assets/Events/RadianceAwardstable.jpg",
    alt: "Radiance - Awards Table",
    category: "Radiance",
  },
  {
    id: 7,
    src: "/assets/Events/NurtureNookKids.jpg",
    alt: "NurtureNook 2.0 - Enjoyment",
    category: "NurtureNook",
  },
  {
    id: 8,
    src: "/assets/Events/EnginuityWSO2Visit.jpg",
    alt: "Enginuity 2.0 - Interactive Session",
    category: "Enginuity",
  },
  {
    id: 9,
    src: "/assets/Events/Nurturenook5.jpg",
    alt: "NurtureNook 2.0 - Gift Donation",
    category: "NurtureNook",
  },
  {
    id: 10,
    src: "/assets/Events/Nurturenook6.jpg",
    alt: "NurtureNook 2.0 - Interactive Session",
    category: "NurtureNook",
  },
  {
    id: 11,
    src: "/assets/Events/Radiancelightingoilamp.jpg",
    alt: "Radiance - Lighting the oil lamp",
    category: "Radiance",
  },
  {
    id: 12,
    src: "/assets/Events/OpenWeek2025.jpg",
    alt: "IEEE Open Week 2025",
    category: "Open Week",
  },
];

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const openModal = (image, index) => {
    setSelectedImage(image);
    setCurrentImageIndex(index);
    document.body.style.overflow = "hidden";
  };

  const closeModal = useCallback(() => {
    setSelectedImage(null);
    document.body.style.overflow = "unset";
  }, []);

  const navigateImage = useCallback(
    (direction) => {
      let newIndex;
      if (direction === "next") {
        newIndex =
          currentImageIndex === galleryImages.length - 1
            ? 0
            : currentImageIndex + 1;
      } else {
        newIndex =
          currentImageIndex === 0
            ? galleryImages.length - 1
            : currentImageIndex - 1;
      }
      setCurrentImageIndex(newIndex);
      setSelectedImage(galleryImages[newIndex]);
    },
    [currentImageIndex],
  );

  const handleKeyPress = useCallback(
    (e) => {
      if (e.key === "Escape") closeModal();
      if (e.key === "ArrowRight") navigateImage("next");
      if (e.key === "ArrowLeft") navigateImage("prev");
    },
    [closeModal, navigateImage],
  );

  React.useEffect(() => {
    if (selectedImage) {
      document.addEventListener("keydown", handleKeyPress);
      return () => document.removeEventListener("keydown", handleKeyPress);
    }
  }, [selectedImage, handleKeyPress]);

  return (
    <section id="gallery" className="section gallery">
      <div className="container">
        <h2 className="section-title">Gallery</h2>
        <p className="section-subtitle">
          Capturing moments from our events, workshops, and community activities
        </p>

        <div className="gallery-grid">
          {galleryImages.map((image, index) => (
            <div
              key={image.id}
              className="gallery-item animate-fade-in-up"
              style={{ animationDelay: `${index * 0.05}s` }}
              onClick={() => openModal(image, index)}
            >
              <img src={image.src} alt={image.alt} />
              <div className="gallery-overlay">
                <div className="gallery-info">
                  <span className="gallery-category">{image.category}</span>
                  <h3 className="gallery-title">{image.alt}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedImage && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              <FaTimes />
            </button>

            <button
              className="modal-nav modal-prev"
              onClick={() => navigateImage("prev")}
            >
              <FaChevronLeft />
            </button>

            <img src={selectedImage.src} alt={selectedImage.alt} />

            <button
              className="modal-nav modal-next"
              onClick={() => navigateImage("next")}
            >
              <FaChevronRight />
            </button>

            <div className="modal-info">
              <span className="modal-category">{selectedImage.category}</span>
              <h3 className="modal-title">{selectedImage.alt}</h3>
              <p className="modal-counter">
                {currentImageIndex + 1} of {galleryImages.length}
              </p>
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;
